import { useState, useEffect } from "react";
import { useTranslation } from 'react-i18next';
import Slider from "react-slick";

import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { useSelector, useDispatch } from 'react-redux';
import { setActiveLink } from '../../slices/mainSlice';
import MatchList from "../Match/components/MatchList";

const Luminaires = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const [activeTab, setActiveTab] = useState("tab1");
  const tabs = [
    { id: "tab1", label: t('allGame') },
    { id: "tab2", label: t('liveGame') },
    { id: "tab3", label: t('preMatch') },
  ];

  useEffect(() => {
    // dispatch(setActiveLink("luminaires"))
  }, [])

  const PrevArrow = ({ className, onClick }) => (
    <button className={`${className} !left-0 z-10`} onClick={onClick} type="button">
      <img
        src="../../assets/images/icons/arrow-chevron-left.svg"
        alt="prev"
        className="w-6 h-6"
      />
    </button>
  );

  const NextArrow = ({ className, onClick }) => (
    <button className={`${className} !right-0 z-10`} onClick={onClick} type="button">
      <img
        src="../../assets/images/icons/arrow-chevron-right.svg"
        alt="next"
        className="w-6 h-6"
      />
    </button>
  );

  const settings = {
    dots: false,
    arrows: true,
    infinite: true,
    autoplay: true,
    autoplaySpeed: 4000,
    speed: 1000,
    slidesToShow: 1,
    slidesToScroll: 1,
    prevArrow: <PrevArrow />,
    nextArrow: <NextArrow />,
    responsive: [
      {
        breakpoint: 1024,
        settings: { slidesToShow: 1 }
      },
      {
        breakpoint: 640,
        settings: { slidesToShow: 1 }
      }
    ]
  };

  return (
    <main class="main p-4 relative">
      <div class="flex flex-col">
        <div class="flex flex-wrap items-start gap-y-6 -mx-2">
          <div class="lg:w-4/6 w-full px-2">
            <div class="space-y-5">
              <div class="relative">
                <div class="rounded-xl absolute inset-0 bg-[#F8F8F8] overflow-hidden">
                  <div class="absolute -skew-x-[20deg] w-[14vw] top-0 -left-12 bottom-0 bg-[#B50613] before:content-[''] before:absolute before:w-1/3 before:top-0 before:left-0 before:bottom-0 before:bg-black/20"></div>
                  <div class="absolute -skew-x-[20deg] w-[14vw] top-0 -right-12 bottom-0 bg-[#3D54AC] before:content-[''] before:absolute before:w-1/3 before:top-0 before:right-0 before:bottom-0 before:bg-black/10"></div>
                </div>
                <div class="relative bg-cover bg-no-repeat bg-center h-full text-center">
                  <div class="flex lg:justify-between justify-center max-sm:flex-wrap gap-y-3 w-full">
                    <div class="flex-none max-sm:w-1/2 max-lg:w-1/3 lg:-mt-4 relative">
                      <img src={require("../../assets/images/club-players/sb29.png")} alt="" class="max-w-full lg:max-h-[276px] inline-block" />
                      <div class="absolute top-3/4 right-0 -translate-y-1/2 size-20 flex justify-center items-center p-4 rounded-full border light-border bg-white">
                        <img src={require("../../assets/images/clubs/sb29.png")} alt="" />
                      </div>
                    </div>
                    <div class="p-5 flex items-center max-sm:order-last">
                      <div class="space-y-2">
                        <h4 class="lg:text-xl md:text-lg text-base font-bold uppercase text-gray-400">30 August 2025</h4>
                        <p class="my-5 font-secondary lg:text-6xl text-3xl font-black leading-none text-gray-800">1:00</p>
                        <p class="font-secondary lg:text-xl font-bold md:text-lg text-base uppercase text-gray-400">Paris Saint-Germain FC Stade Brestois 29</p>
                      </div>
                    </div>
                    <div class="flex-none max-sm:w-1/2 max-lg:w-1/3 lg:-mt-4 relative">
                      <img src={require("../../assets/images/club-players/paris.png")} alt="" class="max-w-full lg:max-h-[276px] inline-block" />
                      <div class="absolute top-3/4 left-0 -translate-y-1/2 size-20 flex justify-center items-center p-4 rounded-full border light-border bg-white">
                        <img src={require("../../assets/images/clubs/paris.png")} alt="" />
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="flex items-center gap-3">
                <h3 class="xl:text-2xl text-xl font-extrabold uppercase">{t('league1Ranking')}</h3>
                <select class="form-select font-bold !max-w-[200px]">
                  <option value="">{t('season')} 2025/25</option>
                  <option value="">{t('season')} 2025/25</option>
                </select>
                <button class="btn btn-primary text-nowrap ml-auto">{t('seeAll')}</button>
              </div>

              <div class="">
                <ul class="mb-3 nav nav-tabs flex border-b light-border [&>*]:flex-1 [&>*]:nav-item [&>*]:inline-flex [&>*]:justify-center [&>*]:items-center [&>*]:gap-1">
                  {tabs.map((tab) => (
                    <li
                      key={tab.id}
                      className={`nav-item ${activeTab === tab.id
                        ? "active"
                        : ""
                        }`}
                      onClick={() => setActiveTab(tab.id)}
                    >
                      <button>{tab.label}</button>
                    </li>
                  ))}
                </ul>

                <div className="tab-content space-y-4">
                  {activeTab === "tab1" && (
                    <div className="tab-pane">
                      <MatchList/>
                    </div>
                  )}
                  {activeTab === "tab2" && (
                    <div className="tab-pane">{t('liveGameContent')}</div>
                  )}
                  {activeTab === "tab3" && (
                    <div className="tab-pane">{t('preMatchContent')}</div>
                  )}
                </div>

              </div>
            </div>
          </div>
          <div class="lg:w-2/6 w-full px-2 space-y-8 sticky top-20">

            <div class="panel space-y-3">
              <div class="panel-header w-full flex flex-wrap justify-center items-center gap-3">
                <div class="flex justify-center gap-3 w-full">
                  {/* <button class="cursor-pointer"><img src="assets/images/icons/arrow-chevron-left.svg" alt="" /></button> */}
                  <h3 class="xl:text-lg text-base font-extrabold uppercase">{t('currentlyPlaying')}</h3>
                  {/* <button class="cursor-pointer"><img src="assets/images/icons/arrow-chevron-right.svg" alt="" /></button> */}
                </div>
              </div>
              <div class="panel-body w-full space-y-4 [&_.slick-arrow]:-top-7 [&_.slick-arrow]:z-10 before:[&_.slick-arrow]:hidden [&_.slick-prev]:left-0 [&_.slick-next]:right-0 ">
                <Slider {...settings}>
                  <div class="bg-[url('../public/assets/images/curve-box.svg')] bg-[length:100%_auto] bg-no-repeat relative before:content-[''] before:absolute before:top-[6vw] before:left-0 before:bottom-0 before:right-0 before:bg-[#F8F8F8] before:rounded-b-lg">
                    <div class="p-5 text-center relative space-y-3">
                      <h4 class="text-lg font-bold text-gray-400 uppercase">30 August 2025</h4>
                      <div class="flex justify-between items-center gap-4 w-full">
                        <div class="flex-none w-16">
                          <img src={require("../../assets/images/clubs/paris.png")} alt="" class="h-24 object-contain" />
                        </div>
                        <div class="flex-1 font-secondary text-4xl font-black">12:15</div>
                        <div class="flex-none w-16">
                          <img src={require("../../assets/images/clubs/sb29.png")} alt="" class="h-24 object-contain" />
                        </div>
                      </div>
                    </div>
                    <div class="px-5 py-2 rounded-b-xl bg-[#FCE3E3] relative flex gap-4 justify-between">
                      <div class="font-secondary text-lg font-bold uppercase">{t('france')}</div>
                      <div class="font-secondary text-lg font-bold uppercase">{t('spain')}</div>
                    </div>
                  </div>
                  <div class="bg-[url('../public/assets/images/curve-box.svg')] bg-[length:100%_auto] bg-no-repeat relative before:content-[''] before:absolute before:top-[6vw] before:left-0 before:bottom-0 before:right-0 before:bg-[#F8F8F8] before:rounded-b-lg">
                    <div class="p-5 text-center relative space-y-3">
                      <h4 class="text-lg font-bold text-gray-400 uppercase">30 August 2025</h4>
                      <div class="flex justify-between items-center gap-4 w-full">
                        <div class="flex-none w-16">
                          <img src={require("../../assets/images/clubs/sb29.png")} alt="" class="h-24 object-contain" />
                        </div>
                        <div class="flex-1 font-secondary text-4xl font-black">12:15</div>
                        <div class="flex-none w-16">
                          <img src={require("../../assets/images/clubs/rcl.png")} alt="" class="h-24 object-contain" />
                        </div>
                      </div>
                    </div>
                    <div class="px-5 py-2 rounded-b-xl bg-[#FCE3E3] relative flex gap-4 justify-between">
                      <div class="font-secondary text-lg font-bold uppercase">{t('france')}</div>
                      <div class="font-secondary text-lg font-bold uppercase">{t('spain')}</div>
                    </div>
                  </div>
                  <div class="bg-[url('../public/assets/images/curve-box.svg')] bg-[length:100%_auto] bg-no-repeat relative before:content-[''] before:absolute before:top-[6vw] before:left-0 before:bottom-0 before:right-0 before:bg-[#F8F8F8] before:rounded-b-lg">
                    <div class="p-5 text-center relative space-y-3">
                      <h4 class="text-lg font-bold text-gray-400 uppercase">30 August 2025</h4>
                      <div class="flex justify-between items-center gap-4 w-full">
                        <div class="flex-none w-16">
                          <img src={require("../../assets/images/clubs/paris.png")} alt="" class="h-24 object-contain" />
                        </div>
                        <div class="flex-1 font-secondary text-4xl font-black">12:15</div>
                        <div class="flex-none w-16">
                          <img src={require("../../assets/images/clubs/sb29.png")} alt="" class="h-24 object-contain" />
                        </div>
                      </div>
                    </div>
                    <div class="px-5 py-2 rounded-b-xl bg-[#FCE3E3] relative flex gap-4 justify-between">
                      <div class="font-secondary text-lg font-bold uppercase">{t('france')}</div>
                      <div class="font-secondary text-lg font-bold uppercase">{t('spain')}</div>
                    </div>
                  </div>
                </Slider>
              </div>
            </div>
          </div>
        </div>
      </div>
    </main>
  );
};

export default Luminaires;
